<template>
  <header class="site-header root box">
    <div class="wrapper page-width">
      <a class="site-header__home-link" href="/">
        <transition name="grow">
          <div v-if="appLoaded" class="site-header__image-box">
            <ResponsiveImg
              class="site-header__image"
              alt="Portrait shot of Miguel N. Galace"
              src="v1576307468/galacemiguel.com/20190103_074056"
            />
          </div>
        </transition>
        <div class="transition-box">
          <transition name="ascend">
            <h1
              v-if="appLoaded"
              class="name typ__size_md typ__style_uppercase typ__tracking_loose"
            >Miguel N. Galace</h1>
          </transition>
        </div>
      </a>
    </div>
  </header>
</template>

<script>
import ResponsiveImg from '@/components/ResponsiveImg'

export default {
  name: 'SiteHeader',
  props: {
    appLoaded: Boolean
  },
  components: {
    ResponsiveImg
  }
}
</script>

<style scoped lang="scss">
.root {
  font-size: 1rem;
}

.box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: $sz__site-header-height;
}

.wrapper {
  display: flex;
  align-items: flex-end;
  height: 100%;
  overflow: hidden;
}

.site-header__home-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  will-change: transform;

  &:hover {
    .site-header__image {
      transform: scale(1.1);
    }

    .site-header__image-box::after {
      opacity: 1;
    }
  }
}

.site-header__image-box {
  position: relative;
  width: 3em;
  height: 3em;
  border-radius: 999px;
  margin-right: 1em;
  overflow: hidden;
  transition: background-color $tm__slow-animation;
  will-change: transform;

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: inset 0 0 2em rgba(0, 0, 0, 0.2);
    opacity: 0;
    transition: opacity $tm__fast-animation;
    content: "";
  }
}

.site-header__image {
  width: 100%;
  transition: transform $tm__fast-animation;
}

.name {
  width: 7em;
  margin-bottom: 0;
  overflow: hidden;
}

/* * * * * * * * * *
* TRANSITIONS
*/
.grow-enter-active {
  transition: transform $tm__intro-animation $tm__ease-in-out-quint;
}

.grow-enter {
  transform: scale(0);
}

.ascend-enter-active {
  transition: transform $tm__intro-animation $tm__ease-in-out-quint;
}

.ascend-enter {
  transform: translateX(-100%);
}
</style>
